import { makeStyles } from '@material-ui/core';
import { Button } from 'components/Base';
import React, { useState, useEffect } from 'react';

const useStyles = makeStyles({
  fileContainer: {},
  fileName: { wordBreak: 'break-all' },
  fileActions: { display: 'flex', gap: '0.5rem', marginTop: '0.5rem' },
  imagePreview: { maxWidth: '250px' }
});

const FileUpload = ({ field, form, accept, url, fileName, ...props }: any) => {
  const classes = useStyles();
  const [isImage, setIsImage] = useState(false);
  const [currentName, setCurrentName] = useState(fileName);
  const [currentUrl, setCurrentUrl] = useState(url);

  const determineIsImage = (file = null as any) => {
    if (file) {
      return file.type.startsWith('image');
    }

    return url && url.match(/\.(jpeg|jpg|gif|png)/) != null;
  };

  useEffect(() => {
    setIsImage(determineIsImage());
  }, []);

  const updateFile = (file: any) => {
    setIsImage(determineIsImage(file));
    setCurrentName(file?.name);
    setCurrentUrl(file ? URL.createObjectURL(file) : null);
  };

  const handleChange = (event: any) => {
    const file = event.currentTarget.files[0];
    updateFile(file);
    form.setFieldValue(field.name, file);
  };

  const removeFile = () => {
    updateFile(null);
    form.setFieldValue(field.name, '');
  };

  return (
    <div>
      {currentUrl ? (
        <div className={classes.fileContainer}>
          {isImage ? (
            <img
              src={currentUrl}
              alt="Current Image"
              className={classes.imagePreview}
            />
          ) : (
            <div className={classes.fileName}>
              {currentName ? currentName.split('/').pop() : <></>}
            </div>
          )}
          <div className={classes.fileActions}>
            <Button type="button" color="primary" onClick={removeFile}>
              Remove File
            </Button>
            <Button component="label">
              Change File
              <input
                type="file"
                hidden
                onChange={handleChange}
                accept={accept}
                {...props}
              />
            </Button>
          </div>
        </div>
      ) : (
        <Button component="label">
          Upload File
          <input
            type="file"
            hidden
            onChange={handleChange}
            accept={accept}
            {...props}
          />
        </Button>
      )}
    </div>
  );
};

export default FileUpload;
